module.exports = __webpack_public_path__ + "static/media/Featured_empty.d45fe178.svg";